module.exports = __webpack_public_path__ + "img/porch_veranda_roof.3112a252.jpg";